import { Buffer } from "buffer";

import { FailoverRpcProvider, JsonRpcProvider } from "@near-js/providers";
import { AccountView, CodeResult } from "@near-js/types";

import { IRPCProviderService, ViewArgs, ViewFunction } from "./interfaces";

export const isVercelEnv = window.location.origin.includes("vercel") || window.location.origin.includes("localhost");

export const fastnearRpc = Math.random() > 0.5 ? "https://c1.rpc.fastnear.com" : "https://c2.rpc.fastnear.com";

export const defaultsProviders = [
  "https://rpc.mainnet.pagoda.co",
  "https://rpc.near.org",
  "https://rpc.mainnet.near.org",
  "https://nearrpc.aurora.dev",
  "https://near.drpc.org",
  "https://rpc.ankr.com/near",
  "https://near.blockpi.network/v1/rpc/public",
  "https://1rpc.io/near",
  "https://g.w.lavanet.xyz:443/gateway/near/rpc-http/d201915962f57367c3c57baa1c72df72",
]
  .map((value) => ({ value, sort: Math.random() }))
  .sort((a, b) => a.sort - b.sort)
  .map(({ value }) => value);

const providers = isVercelEnv ? defaultsProviders : [fastnearRpc, ...defaultsProviders];

const jsonProviders = providers.map(
  (url) =>
    new JsonRpcProvider(
      {
        url,
      },
      { retries: 2 },
    ),
);

export class NearRPCProviderService implements IRPCProviderService {
  private provider: FailoverRpcProvider;

  constructor() {
    const provider = new FailoverRpcProvider(jsonProviders);
    this.provider = provider;
  }

  async viewFunction<T extends keyof ViewFunction>(method: T, accountId: string, args: ViewArgs[T]) {
    try {
      if (!this.provider) {
        console.warn("No Provider selected");
        return undefined;
      }
      const response = await this.provider.query<CodeResult>({
        request_type: "call_function",
        finality: "final",
        account_id: accountId,
        method_name: method,
        args_base64: Buffer.from(JSON.stringify(args)).toString("base64"),
      });
      const result: ViewFunction[typeof method] = JSON.parse(Buffer.from(response.result).toString());
      return result;
    } catch (error) {
      console.error(
        `${error} \n\n %c while calling method ${method} on contract ${accountId}`,
        "color: #5A3B5F; font-weight: 600;",
      );
      return undefined;
    }
  }

  async viewAccount(accountId: string) {
    try {
      if (!this.provider) {
        console.warn("No Provider selected");
        return undefined;
      }
      return await this.provider.query<AccountView>({
        request_type: "view_account",
        finality: "final",
        account_id: accountId,
      });
    } catch (error) {
      console.error(`${error} \n\n %c account_id: ${accountId}`, "color: #5A3B5F; font-weight: 600;");
      return undefined;
    }
  }
}
export * from "./interfaces";
